exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--4-1!../../node_modules/postcss-loader/index.js??postcss!../../node_modules/@syncfusion/ej2-base/styles/material.css"), "");
exports.i(require("-!../../node_modules/css-loader/index.js??ref--4-1!../../node_modules/postcss-loader/index.js??postcss!../../node_modules/@syncfusion/ej2-angular-navigations/styles/material.css"), "");

// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main